import api from "./api";

export const getSuggestedStoryInputs = async () => {
  const response = await api.get('/api/stories/suggestion');
  return response.data;
}

export const generateStory = async (storyInputs) => {
  const response = await api.post('/api/stories/generate-story', {storyInputs});
  return response.data;
};

export const getStoryGenerationStatus = async (storyId) => {
  const response = await api.get(`/api/stories/${storyId}/status`);
  return response.data;
}

export const getStory = async (storyId) => {
  const response = await api.get(`/api/stories/${storyId}`);
  return response.data;
};

export const getStoryBySlug = async (slug) => {
  const response = await api.get(`/api/stories/slug/${slug}`);
  return response.data;
};

export const getMyStories = async (page) => {
  const response = await api.get(`/api/stories/my-stories?page=${page}`);
  return response.data;
}

export const getRandomPublicStories = async (lang, exclude = []) => {
  const response = await api.get(`/api/stories/public?lang=${lang}&exclude=${exclude}`);
  return response.data;  
};

export const getLikedStories = async (page) => {
  const response = await api.get(`/api/stories/liked-stories?page=${page}`);
  return response.data;
}

export const getStoryCoverById = async (storyId) => {
  const response = await api.get(`/api/stories/cover/${storyId}`);
  return response.data;
}

export const deleteStory = async (storyId) => {
  const response = await api.delete(`/api/stories/${storyId}`);
  return response.data;
}

export const submitFeedback = async (storyId, feedbackText) => {
  const response = await api.post(`/api/stories/${storyId}/feedbacks`, {
      feedbackText
  });
  return response.data;
};
  
export const getStoryFeedbacks = async (storyId, page = 1, limit = 5) => {
  const response = await api.get(`api/stories/${storyId}/feedbacks?page=${page}&limit=${limit}`);
  return response.data;
};

export const getStoryFeedbackSummary = async (storyId) => {
  const response = await api.get(`api/stories/${storyId}/summary`);
  return response.data;
};

export const toggleStoryPublicStatus = async (storyId) => {
  const response = await api.put(`/api/stories/public/${storyId}`, null);
  return response.data;
};
  
export const reactStory = async (storyId, reaction) => {
  const response = await api.post(`/api/stories/${storyId}/react`, { reaction });
  return response.data;
};

export const getStoryPDFDownloadLink = async (storyId) => {
  const response = await api.get(`/api/stories/${storyId}/pdf-url`);
  return response.data;
}